// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"3e0dbd87","598":"3e0dbd87"}[chunkId] + ".chunk.css";
};